export default "__VITE_ASSET__BsDSr1sN__"